<div class="email-dialog"
    style="display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 30px; gap: 20px; text-align: center;">

    <div style="display: flex; align-items: center; gap: 10px; font-size: 18px; ">
        <span style="font-size: 30px; color: green;">✔</span>
        <span>Email has been successfully sent to the specified recipients.</span>
    </div>

    <div class="button-section" style="display: flex; justify-content: center;">
        <button mat-flat-button color="primary" (click)="closeDialog()">Ok</button>
    </div>
</div>